// extracted by mini-css-extract-plugin
export var divider = "_31-0";
export var dividerText = "_31-1";